import React from 'react';

const Pagination = ({ currentPage, totalPages, setCurrentPage, totalItems, recordsPerPage = 10 }) => {
  if (totalPages <= 1) return null;

  const startRecord = (currentPage - 1) * recordsPerPage + 1;
  const endRecord = Math.min(currentPage * recordsPerPage, totalItems || (totalPages * recordsPerPage));

  // Determine which page numbers to show
  let pages = [];
  if (totalPages <= 5) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);
    
    if (currentPage <= 3) {
      endPage = 5;
    } else if (currentPage >= totalPages - 2) {
      startPage = totalPages - 4;
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
  }

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between p-4 bg-slate-900/40 rounded-b-xl border-t border-slate-800/50 gap-4 sm:gap-0 mt-2">
      <div className="text-sm font-medium text-slate-400">
        {totalItems ? `Showing ${startRecord}-${endRecord} of ${totalItems}` : `Page ${currentPage} of ${totalPages}`}
      </div>
      
      <div className="flex items-center gap-1">
        <button 
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
          disabled={currentPage === 1} 
          className="px-3 py-1.5 text-sm font-semibold text-slate-400 disabled:opacity-30 hover:text-white transition flex items-center gap-1 mr-2"
        >
          &larr; Prev
        </button>
        
        {pages.map(page => (
          <button
            key={page}
            onClick={() => setCurrentPage(page)}
            className={`min-w-[32px] h-8 px-2 flex items-center justify-center rounded-lg text-sm font-bold transition ${
              currentPage === page 
                ? 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/20' 
                : 'text-slate-400 hover:text-white hover:bg-slate-800/70'
            }`}
          >
            {page}
          </button>
        ))}
        
        <button 
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
          disabled={currentPage === totalPages} 
          className="px-3 py-1.5 text-sm font-semibold text-slate-400 disabled:opacity-30 hover:text-white transition flex items-center gap-1 ml-2"
        >
          Next &rarr;
        </button>
      </div>
    </div>
  );
};

export default Pagination;
